import { render } from "./ChevronRightIcon.vue?vue&type=template&id=65a35d46"
import script from "./ChevronRightIcon.vue?vue&type=script&lang=js"
export * from "./ChevronRightIcon.vue?vue&type=script&lang=js"
script.render = render

export default script